import { Modal } from "components";
import { useState } from "react";
import { MarkAsDeadForm } from "animals/MarkAsDeadForm";
import { CreateNewContactForm } from "animals/CreateNewContactForm";

type AnimalId = string;

interface Props {
  animalIds: Array<AnimalId>;
  showModal: boolean;
  onClose: () => void;
}

export type ModalContent = "markAsDeadForm" | "createNewContactForm";

export const MarkAsDeadModal: React.FC<Props> = ({ animalIds, showModal, onClose }) => {
  const [displayModal, setDisplayModal] = useState(showModal);
  const [modalContent, setModalContent] = useState<ModalContent>("markAsDeadForm");

  const handleCloseModal = () => {
    setDisplayModal(false);
    onClose();
  };

  return (
    <>
      <Modal
        active={displayModal}
        title={modalContent === "markAsDeadForm" ? `Mark Animal as Dead` : `Create New Contact`}
      >
        {modalContent === "markAsDeadForm" ? (
          <MarkAsDeadForm
            animalIds={animalIds}
            handleCloseModal={handleCloseModal}
            changeModalContent={() => setModalContent("createNewContactForm")}
            onCancel={handleCloseModal}
          />
        ) : (
          <CreateNewContactForm
            onCancel={() => setModalContent("markAsDeadForm")}
            onConfirm={() => setModalContent("markAsDeadForm")}
          />
        )}
      </Modal>
    </>
  );
};
